<template>
  <div class="details">
    <!--答案展示、重新答题-->
    <div class="sec-block1 sec-block2" v-if="!answerForcedDisplay && (topicList.length || examSubmitted)">
      <div class="btns">
        <div class="show-answer-btn" @click="openShowAnswer">答案展示</div>
        <div class="reset-btn" @click="resetExam">
          <img src="@/assets/images/grade/img4.png" class="icon-reset" alt="">
          重新答题
        </div>
      </div>
    </div>
    <div class="exam-result-summary" v-if="examSubmitted && examResult">
      <span>最近一次成绩：{{ formatScore(examResult.score) }}</span>
      <span :class="examResult.attemptPassed ? 'pass' : 'fail'">{{ examResult.attemptPassed ? '本次通过' : '本次未通过' }}</span>
      <span v-if="examResult.hasPassed">本考试曾有一次通过记录</span>
    </div>
    <!--题目描述-->
    <div class="sec-block1" v-if="topicList.length">
      <div class="title">题目描述</div>
      <div class="abs-btn">
        <div class="btn-txt" @click="showDialog = !showDialog">题目列表</div>
        <div class="case-num">
          <span class="num-col">{{ curTopic.curIndex || 1 }}</span>
          /{{ topicList.length }}
        </div>
      </div>
    </div>
    <!--答题组件-->
    <item-components
      v-if="dayDetails.id && topicList.length"
      ref="itemSwitch"
      :topic-list="topicList"
      :day-details="dayDetails"
      :question-image="questionImage"
      :question-video="questionVideo"
      :item-ids="itemIds"
      :true-answer-id="trueAnswerId"
      :answer-status="answerStatus"
      :user-answer="userAnswer"
      :answer-is-true="answerIsTrue"
      :true-txt="trueTxt"
      :analysis-video="analysisVideo"
      :question-courses="questionCourses"
      :question-documents="questionDocuments"
      :question-cases="questionCases"
      :answer-forced-display="answerForcedDisplay"
      :submitted-read-only="examSubmitted && !answerForcedDisplay"
      @swipe-change="onChange"
      @image-click="previewImage"
      @question-video-click="playQuestionVideo"
      @option-click="pickOption"
      @play-video="playAnalysisVideo"
    ></item-components>
    <!--上一题、下一题、提交本场考试-->
    <div class="fix-btn" v-if="topicList.length">
      <div
        class="btn-txt"
        v-if="!examSubmitted && !answerForcedDisplay && topicList.length"
        @click="confirmAnswer"
      >{{ curSwiperIndex === topicList.length - 1 ? '提交本场考试' : '确认并继续' }}</div>
      <div class="flex-btn">
        <div class="btn-item" @click="goPrev">
          <img src="@/assets/images/questionBank/img(9).png" class="item-icon" alt="">
          <div class="item-txt">上一题</div>
        </div>
        <div class="btn-item" @click="goNext">
          <img src="@/assets/images/questionBank/img(17).png" class="item-icon" alt="">
          <div class="item-txt">下一题</div>
        </div>
      </div>
    </div>
    <!--题目列表-->
    <index-components
      v-if="topicList.length"
      :show-all="showDialog"
      :topic-list="topicList"
      :show-draft-answers="true"
      @update:showAll="showDialog = $event"
      @topic-click="goTopic"
    ></index-components>
    <!--查看答案确认、交卷结果-->
    <dialog-del
      ref="dialogDel"
      :dialog-head-txt="dialogHeadTxt"
      :del-message="delMessage"
      @handleDelSave="onDialogConfirm"
    ></dialog-del>
    <div class="dialog-video" v-if="videoDialog">
      <div class="dialog-video-bg" @click.stop="handlePauseVideo"></div>
      <VideoPlayerAnswer ref="video" :playerVideo="videoPlayerSource"></VideoPlayerAnswer>
    </div>
  </div>
</template>

<script>
import { ImagePreview } from 'vant'
import withRouteTracking from '@/utils/withRouteTracking'
import { stopScroll, canScroll } from '@/utils/util'
import itemComponents from '@/components/questionCom/itemComponents.vue'
import indexComponents from '@/components/questionCom/indexComponents.vue'
import VideoPlayerAnswer from '@/views/home/components/VideoPlayerAnswer.vue'
import dialogDel from '@/views/grade/components/dialogDel.vue'
import {
  getResearchCampPlanExam,
  getResearchCampCustomExam,
  startResearchCampPlanExam,
  startResearchCampCustomExam,
  submitResearchCampExam,
  viewResearchCampExamAnswers,
  getResearchCampExamReview
} from '@/api/researchCamp'

const CampExam = {
  name: 'CampExam',
  components: {
    VideoPlayerAnswer,
    itemComponents,
    indexComponents,
    dialogDel
  },
  data () {
    return {
      passLine: 85,
      planItemId: null,
      dispatchMemberId: null,
      activeAttemptId: null,
      attemptNo: null,
      examInfo: {},
      examResult: null,
      examSubmitted: false,
      canRetake: true,
      submitting: false,
      topicList: [],
      curSwiperIndex: 0,
      curTopic: {},
      dayDetails: {},
      questionImage: {},
      questionVideo: {},
      itemIds: [],
      trueAnswerId: [],
      answerStatus: '2',
      userAnswer: [],
      answerIsTrue: '',
      trueTxt: '',
      analysisVideo: {},
      videoPlayerSource: {},
      videoDialog: false,
      questionCourses: [],
      questionDocuments: [],
      questionCases: [],
      answerForcedDisplay: false,
      showDialog: false,
      dialogHeadTxt: '提示',
      delMessage: '',
      dialogConType: ''
    }
  },
  mounted () {
    this.loadExam()
  },
  methods: {
    // 按计划项或定制任务加载考试
    async loadExam () {
      try {
        const query = this.$route.query || {}
        this.planItemId = query.planItemId ? String(query.planItemId) : null
        this.dispatchMemberId = query.dispatchMemberId ? String(query.dispatchMemberId) : null
        if ((!this.planItemId && !this.dispatchMemberId) || (this.planItemId && this.dispatchMemberId)) {
          throw new Error('考试任务参数不正确')
        }
        const response = this.dispatchMemberId
          ? await getResearchCampCustomExam(this.dispatchMemberId)
          : await getResearchCampPlanExam(this.planItemId)
        this.examInfo = response && response.data ? response.data : {}
        this.passLine = Number(this.examInfo.passScore) || 85
        if (this.examInfo.answersViewed) {
          if (!this.examInfo.latestAttemptId) throw new Error('未找到已查看答案的考试记录')
          const reviewResponse = await getResearchCampExamReview(this.examInfo.latestAttemptId)
          this.applyReview(reviewResponse && reviewResponse.data ? reviewResponse.data : {})
          return
        }
        if (this.examInfo.draftAttemptId) {
          if (this.examInfo.canStart === false) {
            throw new Error('前序考试尚未提交，暂不能继续本场考试')
          }
          const attempt = await this.createAttempt()
          if (!attempt.attemptId || !Array.isArray(attempt.questions) || !attempt.questions.length) {
            throw new Error('考试没有可作答题目')
          }
          this.applyAttempt(attempt)
          return
        }
        if (this.examInfo.latestAttemptId && Number(this.examInfo.attemptCount) > 0) {
          const reviewResponse = await getResearchCampExamReview(this.examInfo.latestAttemptId)
          this.applySubmittedAttempt(reviewResponse && reviewResponse.data ? reviewResponse.data : {})
          return
        }
        if (this.examInfo.canStart === false) {
          throw new Error('前序考试尚未提交，暂不能开始本场考试')
        }
        const attempt = await this.createAttempt()
        if (!attempt.attemptId || !Array.isArray(attempt.questions) || !attempt.questions.length) {
          throw new Error('考试没有可作答题目')
        }
        this.applyAttempt(attempt)
      } catch (error) {
        this.$toast(error && (error.msg || error.message) ? (error.msg || error.message) : '考试加载失败')
      }
    },
    // 创建或继续一场作答
    async createAttempt () {
      const response = this.dispatchMemberId
        ? await startResearchCampCustomExam(this.dispatchMemberId)
        : await startResearchCampPlanExam(this.planItemId)
      return response && response.data ? response.data : {}
    },
    // 用本次作答题目渲染答题卡
    applyAttempt (attempt) {
      this.activeAttemptId = attempt.attemptId
      this.attemptNo = attempt.attemptNo
      this.examSubmitted = Number(attempt.submitStatus) === 2
      this.examResult = null
      this.canRetake = true
      this.answerForcedDisplay = false
      this.topicList = (attempt.questions || []).map((question, index) => {
        const serverAnswer = Array.isArray(question.studentOptionLabels) ? question.studentOptionLabels : []
        return this.toQuestion(question, index, serverAnswer, false)
      })
      this.resetQuestionView()
    },
    // 查看答案后进入回顾，不能再改选项
    applyReview (review) {
      this.activeAttemptId = review.attemptId
      this.attemptNo = null
      this.examSubmitted = true
      this.examResult = review
      this.canRetake = review.canRetake === true
      this.answerForcedDisplay = true
      this.topicList = (review.questions || []).map((question, index) => this.toQuestion(question, index, [], true))
      this.resetQuestionView()
    },
    // 已交卷后展示历史选项，但不展示标准答案，仍允许学员重考。
    applySubmittedAttempt (review) {
      this.activeAttemptId = review.attemptId
      this.attemptNo = null
      this.examSubmitted = true
      this.examResult = review
      this.canRetake = review.canRetake === true
      this.answerForcedDisplay = false
      this.topicList = (review.questions || []).map((question, index) => {
        const studentLabels = Array.isArray(question.studentOptionLabels) ? question.studentOptionLabels : []
        return this.toQuestion(question, index, studentLabels, false)
      })
      this.resetQuestionView()
    },
    // 接口题目转成答题卡结构
    toQuestion (question, index, pickedIds, reviewMode) {
      const options = (question.options || []).map(option => ({
        id: option.label,
        optionContent: option.content || option.text || ''
      }))
      const studentLabels = reviewMode && Array.isArray(question.studentOptionLabels)
        ? question.studentOptionLabels
        : pickedIds
      return {
        id: question.questionId,
        score: question.score,
        questionTitle: question.question ? question.question.title || '' : '',
        questionType: String(question.question && question.question.type ? question.question.type : 1),
        answerStatus: reviewMode ? (question.isCorrect ? '3' : '1') : '2',
        pickedIds: studentLabels.slice(),
        curIndex: index + 1,
        questionImage: question.question ? question.question.questionImage || {} : {},
        questionVideo: question.question ? question.question.questionVideo || {} : {},
        analysisVideo: question.question ? question.question.analysisVideo || {} : {},
        remark: question.question ? question.question.remark || '' : '',
        questionCourses: question.question ? question.question.questionCourses || [] : [],
        questionCases: question.question ? question.question.questionCases || [] : [],
        questionDocuments: question.question ? question.question.questionDocuments || [] : [],
        questionOptions: options,
        correctOptionLabels: reviewMode && Array.isArray(question.correctOptionLabels) ? question.correctOptionLabels : [],
        isCorrect: reviewMode ? question.isCorrect : null
      }
    },
    // 回到第一题
    resetQuestionView () {
      this.curSwiperIndex = 0
      this.curTopic = {}
      this.dayDetails = {}
      this.$nextTick(() => {
        this.applyCurrent()
        if (this.$refs.itemSwitch && this.$refs.itemSwitch.$refs.vantSwiper) {
          this.$refs.itemSwitch.$refs.vantSwiper.swipeTo(0)
        }
      })
    },
    // 同步当前题的选项和作答状态
    applyCurrent () {
      const question = this.topicList[this.curSwiperIndex]
      if (!question) return
      question.curIndex = this.curSwiperIndex + 1
      this.curTopic = question
      this.dayDetails = question
      this.answerStatus = question.answerStatus
      this.itemIds = (question.pickedIds || []).slice()
      this.questionImage = question.questionImage || {}
      this.questionVideo = question.questionVideo || {}
      this.analysisVideo = question.analysisVideo || {}
      this.questionCourses = question.questionCourses || []
      this.questionCases = question.questionCases || []
      this.questionDocuments = question.questionDocuments || []
      this.trueAnswerId = question.correctOptionLabels || []
      this.trueTxt = (question.questionOptions || []).filter(item => this.trueAnswerId.includes(item.id))
        .map(item => item.optionContent).join('、')
      this.userAnswer = this.answerForcedDisplay
        ? this.itemIds.map(id => ({ questionOption: { id } }))
        : []
      this.answerIsTrue = question.isCorrect === true ? 'true' : question.isCorrect === false ? 'false' : ''
    },
    // 滑动切换题目
    onChange (index) {
      this.curSwiperIndex = index
      this.applyCurrent()
    },
    // 跳到指定题目
    goTopic (index) {
      if (index === this.curSwiperIndex) {
        this.showDialog = false
        return
      }
      this.showDialog = false
      this.$refs.itemSwitch.$refs.vantSwiper.swipeTo(index)
    },
    // 上一题
    goPrev () {
      if (this.curSwiperIndex === 0) {
        this.$toast('这里是第一题！')
        return
      }
      this.goTopic(this.curSwiperIndex - 1)
    },
    // 下一题
    goNext () {
      if (this.curSwiperIndex === this.topicList.length - 1) {
        this.$toast('您已到最后一题！')
        return
      }
      this.goTopic(this.curSwiperIndex + 1)
    },
    // 单选替换、多选切换
    pickOption (id) {
      if (this.answerForcedDisplay || this.examSubmitted || this.answerStatus !== '2') return
      if (this.dayDetails.questionType === '1') {
        this.itemIds = [id]
      } else {
        this.itemIds = this.itemIds.indexOf(id) > -1
          ? this.itemIds.filter(item => item !== id)
          : this.itemIds.concat(id)
      }
      this.topicList[this.curSwiperIndex].pickedIds = this.itemIds.slice()
    },
    // 确认本题。最后一题直接交卷
    async confirmAnswer () {
      if (this.answerForcedDisplay || this.examSubmitted || this.answerStatus !== '2' || this.submitting) return
      if (!this.itemIds.length) {
        this.$toast('作题答案不能为空！')
        return
      }
      if (this.dayDetails.questionType === '2' && this.itemIds.length < 2) {
        this.$toast('该题为多选题，请至少选择两个选项！')
        return
      }
      if (this.curSwiperIndex === this.topicList.length - 1) {
        await this.submitExam()
      } else {
        this.goTopic(this.curSwiperIndex + 1)
      }
    },
    // 全部作答完成后提交
    async submitExam () {
      const invalidIndex = this.topicList.findIndex(question => !question.pickedIds.length ||
        (question.questionType === '2' && question.pickedIds.length < 2))
      if (invalidIndex >= 0) {
        this.goTopic(invalidIndex)
        this.$toast('请完成所有题目后再提交')
        return
      }
      this.submitting = true
      try {
        const answers = this.topicList.map(question => ({
          questionId: question.id,
          optionLabels: question.pickedIds.slice()
        }))
        const response = await submitResearchCampExam(this.activeAttemptId, { answers })
        this.examResult = response && response.data ? response.data : {}
        this.examSubmitted = true
        this.canRetake = this.examResult.canRetake !== false
        this.openResult()
      } catch (error) {
        this.$toast(error && error.msg ? error.msg : '考试提交失败')
      } finally {
        this.submitting = false
      }
    },
    // 预览题目图片
    previewImage () {
      if (!this.questionImage || !this.questionImage.url) return
      ImagePreview({ images: [this.questionImage.url], showIndex: false, closeable: true })
    },
    // 播放题干视频。
    playQuestionVideo () {
      this.openVideo(this.questionVideo)
    },
    // 播放答案解析视频。
    playAnalysisVideo () {
      this.openVideo(this.analysisVideo)
    },
    openVideo (video) {
      if (!video || (!video.id && !video.fileId && !video.url)) return
      window.sessionStorage.setItem('video-track-cache', JSON.stringify({
        entrance: 181,
        campId: (this.dayDetails && this.dayDetails.id) || '',
        channel: 181
      }))
      this.videoPlayerSource = video
      this.videoDialog = true
      stopScroll()
      this.$nextTick(() => {
        if (!this.$refs.video) return
        this.$refs.video.curVideoPlayer.sectionId = video.id
        this.$refs.video.player.play()
      })
    },
    handlePauseVideo () {
      if (this.$refs.video && this.$refs.video.player && this.$refs.video.player.pause) {
        this.$refs.video.player.pause()
      }
      this.videoDialog = false
      canScroll()
    },
    // 查看答案前确认。查看后不能再考
    openShowAnswer () {
      if (!this.examSubmitted || !this.examResult || !this.examResult.canReview) {
        this.$toast('提交考试后才能查看答案')
        return
      }
      this.dialogHeadTxt = '答案展示'
      this.delMessage = '查看答案后不可再次答题，是否确认查看答案？'
      this.dialogConType = 'showAnswer'
      this.$refs.dialogDel.init()
    },
    // 最后一题交卷后按 85 分提示通关或未通过
    openResult () {
      const score = Number(this.examResult && this.examResult.score)
      const scoreText = Number.isFinite(score) ? score : 0
      const passed = scoreText >= 85
      this.dialogHeadTxt = '考试结果'
      this.delMessage = passed
        ? `恭喜通关！本次分数为 ${scoreText} 分`
        : `考试未通过，本次分数为 ${scoreText} 分`
      this.dialogConType = 'result'
      this.$refs.dialogDel.init()
    },
    // 确认查看答案后拉取回顾。交卷结果确认后回到列表
    async onDialogConfirm () {
      const leaveAfterClose = this.dialogConType === 'result'
      if (this.dialogConType === 'showAnswer') {
        try {
          const response = await viewResearchCampExamAnswers(this.activeAttemptId)
          this.applyReview(response && response.data ? response.data : {})
        } catch (error) {
          this.$toast(error && error.msg ? error.msg : '答案加载失败')
        }
      }
      this.dialogConType = ''
      this.$refs.dialogDel.handleClose()
      if (leaveAfterClose) this.backToExamList()
    },
    backToExamList () {
      this.$router.back()
    },
    // 重新开一场。已看过答案则不能再考
    async resetExam () {
      if (!this.canRetake) {
        this.$toast('已查看正确答案，不能再次作答')
        return
      }
      try {
        const attempt = await this.createAttempt()
        if (!attempt.attemptId || !Array.isArray(attempt.questions) || !attempt.questions.length) {
          throw new Error('考试没有可作答题目')
        }
        this.applyAttempt(attempt)
      } catch (error) {
        this.$toast(error && (error.msg || error.message) ? (error.msg || error.message) : '重新答题失败')
      }
    },
    // 分数空值显示暂无
    formatScore (score) {
      return score === null || score === undefined ? '暂无' : `${score} 分`
    }
  }
}

export default withRouteTracking(CampExam)
</script>

<style lang="less" scoped>
.details {
  position: relative;
  background-color: #fff;
  padding: 15px;
  padding-bottom: 110px;
  box-sizing: border-box;
  min-height: 100vh;

  .exam-result-summary {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 30px 16px;
    font-size: 14px;
    line-height: 24px;
    color: #666;

    .pass {
      color: #328714;
    }

    .fail {
      color: #eb1700;
    }
  }

  .sec-block1 {
    position: relative;

    &.sec-block2 {
      height: 34px;
      width: 100vw;
      left: -15px;
      top: -15px;
      margin-bottom: 15px;
      background-color: #f5f5f5;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding: 0 16px;
      box-sizing: border-box;

      .btns {
        display: flex;
        align-items: center;
      }

      .show-answer-btn {
        margin-right: 8px;
        width: 68px;
        height: 24px;
        border-radius: 4px;
        border: 1px solid #333;
        font-size: 12px;
        color: #333;
        display: flex;
        align-items: center;
        justify-content: center;
        box-sizing: border-box;
      }

      .reset-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 4px;
        background-color: #eb1700;
        color: #fff;
        font-weight: 500;
        font-size: 12px;
        width: 90px;
        height: 24px;

        .icon-reset {
          display: block;
          width: 12px;
          margin-right: 4px;
        }
      }
    }
  }

  .title {
    font-size: 14px;
    color: #000;
    font-weight: 600;
    padding-left: 8px;
    line-height: 20px;
    position: relative;
    margin-bottom: 8px;

    &::before {
      position: absolute;
      width: 4px;
      left: 0;
      top: 4px;
      height: 12px;
      border-radius: 100px;
      background-color: #eb1700;
      content: '';
    }
  }

  .abs-btn {
    position: absolute;
    right: 0;
    top: -3px;
    display: flex;
    align-items: center;

    .btn-txt {
      padding: 0 4px;
      height: 22px;
      border-radius: 4px;
      border: 1px solid #eb1700;
      color: #eb1700;
      font-size: 12px;
      text-align: center;
      line-height: 22px;
      margin-right: 16px;
      box-sizing: border-box;
    }

    .case-num {
      display: flex;
      align-items: center;
      font-size: 14px;
      font-weight: 500;
      color: #333;

      .num-col {
        color: #eb1700;
      }
    }
  }

  .fix-btn {
    position: fixed;
    left: 0;
    bottom: 0;
    background-color: #fff;
    border-top: 1px solid #f1f1f1;
    padding: 8px 10px;
    box-sizing: border-box;
    width: 100vw;
    z-index: 9;

    .btn-txt {
      width: 100%;
      height: 40px;
      text-align: center;
      font-size: 14px;
      color: #fff;
      line-height: 40px;
      background-color: #eb1700;
      border-radius: 100px;
      margin-bottom: 18px;
    }

    .flex-btn {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .btn-item {
        width: 25%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .item-icon {
          width: 20px;
          height: 20px;
          display: block;
          margin-bottom: 4px;
        }

        .item-txt {
          font-size: 14px;
          line-height: 16px;
          color: rgba(0, 0, 0, 0.8);
        }
      }
    }
  }
}

/deep/ .div-txt {
  font-size: 14px;
  color: #333;
  margin-bottom: 8px;
}

.dialog-video {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
}

.dialog-video-bg {
  width: 100vw;
  height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 9999;
  background-color: rgba(0, 0, 0, 0.6);
}

/deep/ .dialog-video .player {
  position: relative;
  width: 100%;
  height: 200px;
  top: 50%;
  margin-top: -50%;
  z-index: 99999;
}

/deep/ .dialog-video .player.isFullPlayer {
  position: static;
  height: auto;
  top: 0;
  margin-top: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/researchCamp/exam.vue